import { useNavigate } from "react-router-dom";
import BackImg from "@assets/images/stepsBack.jpg";
import ImageWithFallback from "@components/ui/ImageFallback";
import { ReactComponent as Time } from "@assets/images/greenTime.svg";
import { ReactComponent as Dumble } from "@assets/images/dumble.svg";
import { ReactComponent as Loc } from "@assets/images/loc.svg";
import { ReactComponent as Dart } from "@assets/images/dart.svg";
import { useMemo, useState } from "react";
import { addDays, format } from "date-fns";
import { useTranslation } from "react-i18next";

export default function GenerateExcercise({ AllExercises }) {
  const getWeekDates = (date) => {
    const monday = addDays(date, -((date.getDay() + 6) % 7));

    return Array.from({ length: 7 }, (_, i) => addDays(monday, i));
  };
  const { t } = useTranslation();
  const today = new Date();
  const todayDay = format(new Date(), "EEEE").toLowerCase();
  const weekDates = getWeekDates(today);

  const exerciseDays = weekDates
    .map((date) => {
      const day = format(date, "EEEE").toLowerCase();
      return { day, date };
    })
    .filter(({ day }) => AllExercises?.some((entry) => entry?.day === day));

  const dayOrder = exerciseDays.map(({ day }) => day);

  const sortedExercises = [...AllExercises]?.sort(
    (a, b) => dayOrder.indexOf(a?.day) - dayOrder.indexOf(b?.day)
  );
  
  const navigate = useNavigate();
  // const { subscriptionStartDate } = useAuth();
  
  const [activeIndex, setActiveIndex] = useState(() => {
    const index = exerciseDays?.findIndex((item) => item.day === todayDay);
    return index >= 0 ? index : 0;
  });

  const handleNavigateDetail = (item) => {
    // const date = new Date(exerciseDays[activeIndex].date); // e.g., '2025-07-03'
    // const fullDay = date.toLocaleDateString("en-US", { weekday: "long" }); // 'Thursday'
    // console.log(exerciseDays?.[activeIndex].day);
    navigate("/exercise-plan/view-plan", {
      state: { day: exerciseDays?.[activeIndex]?.day },
    });
  };
  const data = useMemo(() => {
    return sortedExercises?.[activeIndex]?.data;
  }, [activeIndex, sortedExercises]);

  // const getYouTubeEmbedUrl = (url) => {
  //   if (!url) return null;
  //   const match = url.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
  //   return match ? `https://www.youtube.com/embed/${match[1]}` : url;
  // };
  // const isYouTubeUrl = (url) => {
  //   const pattern = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//;
  //   return pattern.test(url);
  // };
  return (
    <>
      <div
        className="mt-[30px] lg:mt-[60px] avoid-page-break  p-6 rounded-[18px] bg-cover"
        style={{ backgroundImage: `url(${BackImg})` }}
      >
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-[16px] lg:text-[20px] text-white font-[500] font-[Lato]">
            {t(`exercisePlan.generatePlanHeading`)}
          </h2>
        </div>
        <div className="flex flex-col-reverse gap-4 xl:grid xl:grid-cols-2 md:gap-4">
          <div className="space-y-4">
            <div className="flex items-center rounded-[8px] md:gap-2 w-full border border-[2px] border-[#F2F2F2B8] overflow-y-auto bg-white">
              {exerciseDays?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`flex flex-col flex-1 rounded-[11px] !py-[28px] !px-[10px] cursor-pointer border border-white gap-[10px] bg-white text-black
                    ${
                      activeIndex === index
                        ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white "
                        : "hover:border hover:border-[#0575E6] hover:text-[#0575E6]"
                    }
                    `}
                    onClick={() => setActiveIndex(index)}
                  >
                    <p
                      className={`text-[14px] font-[Lato] font-[400] text-center`}
                    >
                      {t(
                        `daysShort.${item?.date.toLocaleDateString("en-US", {
                          weekday: "short",
                        })}`
                      )}
                    </p>
                    <p className="text-[14px] font-[Lato] text-center">
                      {format(item?.date, "dd MMM")}
                    </p>
                  </div>
                );
              })}
            </div>

            <div className="bg-white rounded-[16px] p-3 md:p-2 flex flex-col md:flex-row items-center gap-2 lg:gap-4">
              <ImageWithFallback
                src={`${data?.image_url}`}
                exercisePlan={true}
                className="w-full md:w-[163px] h-[190px] object-cover rounded-[13px]"
                anonymous={false}
              />
              <div className="w-full p-0 py-1 flex-1">
                <p className="text-[14px] font-[Lato] font-[600] mb-2">
                  {data?.title}
                </p>
                {/* <div className="flex flex-row lg:items-center gap-2 "> */}
                <div className="text-[#4CA842]  text-[12px] bg-[#D7FFD2] rounded-full px-2 py-1 flex items-center gap-2 w-full cursor-default">
                  <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                    <Time />
                  </p>{" "}
                  {t(`exercisePlan.duration`)}: {data?.duration}
                </div>
                <div className="text-[#E58B00]  text-[12px] bg-[#FBEFDB] rounded-full px-2 py-1 flex items-center gap-2 w-full my-2 cursor-default">
                  <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                    <Dumble />
                  </p>{" "}
                  {t(`exercisePlan.Type`)}: {data?.category}
                </div>
                {/* </div> */}
                {/* <div className="flex flex-row lg:items-center gap-2 my-2"> */}
                {/* <div className="text-[#00B7FE]  text-[12px] bg-[#D2FCFF] rounded-full px-2 py-1 flex items-center gap-2 w-full">
                        <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                          <Loc />
                        </p>{" "}
                        {t(`exercisePlan.Location`)}: {data?.location}
                      </div> */}
                <div className="text-[#E50067] text-[12px] bg-[#FBDBEB] rounded-full px-2 py-1 flex items-center gap-2 w-full mb-2 cursor-default">
                  <p className="bg-white rounded-full w-7 h-7 flex items-center justify-center">
                    <Dart />
                  </p>{" "}
                  {t(`exercisePlan.Goal`)}: {data?.goals}
                </div>
                {/* </div> */}
                <button
                  className="w-full text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[4px] py-2 text-[12px] font-[500]"
                  onClick={() => handleNavigateDetail(data)}
                >
                  {t(`exercisePlan.viewPlan`)}
                </button>
              </div>
            </div>
          </div>

          <div className="min-h-[200px] md:min-h-[full]">
            <video
              className="w-full h-full rounded-md shadow-lg object-cover"
              src={sortedExercises?.[activeIndex]?.video_url}
              poster={sortedExercises?.[activeIndex]?.data?.image_url}
              playsInline
              controls
            />
          </div>
        </div>
      </div>
      {/* <ExercisePlanCharts /> */}
    </>
  );
}
